"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const generateMask = (value, { thousandsSeparator, decimalSeparator, precision = 0, }) => {
    const [intPart = '', floatPart = ''] = value.split(decimalSeparator);
    const chunksLength = Math.floor(intPart.length / 3);
    const leadLength = intPart.length % 3;
    const lead = Array(leadLength)
        .fill('#')
        .join('');
    return `${lead ? `${lead}${thousandsSeparator}` : ''}${Array(chunksLength)
        .fill('###')
        .join(' ')}${floatPart ? `${decimalSeparator}${Array(precision).fill('#')}` : ''}`;
};
exports.default = generateMask;
